// extracted by mini-css-extract-plugin
module.exports = {"templatePreview":"TemplatePreview_templatePreview__mu3Ax"};